// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"bbb75b96","513":"9e500215","703":"3ac92f21","787":"ab4113bf"}[chunkId] + ".chunk.js";
};